/** @format */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { getCookie } from '@/shared/lib/formatter'
import { Toast } from '@/shared/ui/organisms/toast'
// Maxsus xatoliklarni qayta ishlovchi log funksiyasi

const MODE = import.meta.env.MODE
// Advanced kimport { getCookie } from '@/shared/lib/formatter';
const dfLan = getCookie('lang') || 'uzCYR'
i18n
  .use(HttpBackend) // Tarjima fayllarini yuklash uchun HTTP backend
  .use(LanguageDetector) // Foydalanuvchi tilini aniqlash
  .use(initReactI18next) // React integratsiyasi
  .init({
    debug: MODE === 'development', // Faqat ishlab chiqishda yoqing
    fallbackLng: dfLan || 'uzCYR', // Default til
    supportedLngs: ['uzCYR', 'uzLAT', 'ruRUS'], // Faqat qo'llab-quvvatlanadigan tillar
    lng: dfLan || 'uzCYR', // Boshlang'ich til
    load: 'languageOnly', // Faqat til kodini yuklang, masalan: `uz`, `ru`
    saveMissing: false, // Backend addPath endpointi yo'q — har missingKey 404 POST yaratardi va dispatch loop'larga olib kelardi
    missingKeyHandler: () => {}, // No-op: hech qanday tarmoq so'rovi yoki dispatch qilinmasin

    interpolation: {
      escapeValue: false, // React avtomatik ravishda qochirilgan qiymatlarni ishlatadi
      // format: (value, format, lng) => {
      //   // Kengaytirilgan format funksiyasi
      //   if (format === 'uppercase') return value.toUpperCase()
      //   if (format === 'lowercase') return value.toLowerCase()
      //   if (format === 'currency') {
      //     if (lng === 'uzCYR') {
      //       return `${value} сўм` // Kirill yozuvida
      //     }
      //     if (lng === 'uzLAT') {
      //       return `${value} so'm` // Lotin yozuvida
      //     }
      //     if (lng === 'ruRUS') {
      //       return `${value} сум` // Rus tili uchun
      //     }
      //     return `$${value}` // Default qiymat
      //   }
      //   if (format === 'measurement ') {
      //     if (lng === 'uzCYR') {
      //       return `${value} м3` // Kirill yozuvida
      //     }
      //     if (lng === 'uzLAT') {
      //       return `${value} m3` // Lotin yozuvida
      //     }
      //     if (lng === 'ruRUS') {
      //       return `${value} м3` // Rus tili uchun
      //     }

      //     return `$${value}` // Default qiymat
      //   }
      // },
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Tarjima fayllarining joylashuvi
      // addPath faqat backend endpoint mavjud bo'lsa yoqilishi kerak
      // addPath: '/locales/{{lng}}/{{ns}}.missing.json', // Yangi tarjimalar uchun
      requestOptions: {
        mode: 'cors', // Cors bilan so'rovlar
        credentials: 'same-origin',
        cache: 'no-cache',
      },
      // React 19 uchun error handling
      onError: (error: any) => {
        if (MODE === 'development') {
          // Missing translation endpoint xatolarini e'tiborsiz qoldirish
          if (!error?.response?.status || error.response.status !== 404) {
            Toast({
              type: 'error',
              message: `i18next backend loading error: ${error.message || String(error)}`,
            })
          }
        }
      },
    },
    detection: {
      // Cookie is the single source of truth for the user's language. Both
      // i18next-browser-languagedetector (this config) and the Zustand
      // language store write the `lang` cookie, so dropping the localStorage
      // cache removes the redundant `i18nextLng` localStorage entry without
      // losing persistence. Aligns with CLAUDE.md hard rule #5 — keep the
      // localStorage surface honest by not accumulating shadow copies of
      // state that already lives in cookies.
      order: ['cookie', 'querystring', 'navigator', 'htmlTag'],
      caches: ['cookie'],
      cookieOptions: {
        path: '/',
        sameSite: 'strict',
        secure: MODE === 'production', // Faqat HTTPS uchun
      },
    },
    react: {
      useSuspense: true, // Re-enabled for proper React 19 re-rendering
      bindI18n: 'languageChanged loaded', // Ensure components re-render on language change
      bindI18nStore: 'added removed', // Re-render when translations are added/removed
      transEmptyNodeValue: '', // Handle empty translation nodes
      transSupportBasicHtmlNodes: true, // Support basic HTML in translations
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'], // Keep these HTML nodes
    },
    ns: ['translation', 'transport-nakladnoy', 'gate', 'accounting'], // Namespace-lar ro'yxati
    defaultNS: 'translation', // Default namespace
    keySeparator: '.', // Tarjima kalitlari uchun ajratgich
    nsSeparator: ':', // Namespace ajratgich
    errorStackTraceLimit: 5, // Maksimal xato stack darajasi
    returnNull: false, // React 19 uchun null return ni oldini olish
  } as any)

export default i18n
